export default class LocationType {
  /**
   * This is a static method that returns a new instance of the LocationType class with the type
   * 'city'.
   * @returns A new instance of the `LocationType` class with the value of `'city'` as its parameter.
   */
  static get City() {
    return new LocationType('city');
  }

/**
 * The above code defines a static getter function that returns a new instance of a LocationType object
 * with the type 'market'.
 * @returns A new instance of the `LocationType` class with the type `market` is being returned.
 */
  static get Market() {
    return new LocationType('market');
  }

  /**
   * The above code defines a static method that returns a new instance of a LocationType object with
   * the type 'rectangularArea'.
   * @returns A new instance of the `LocationType` class with the value `'rectangularArea'` is being
   * returned.
   */
  static get RectangularArea() {
    return new LocationType('rectangularArea');
  }

/**
 * The function returns a new LocationType object with the type 'zip'.
 * @returns A new instance of the `LocationType` class with the argument `'zip'`.
 */
  static get Zip() {
    return new LocationType('zip');
  }

 /**
 * The function returns a new instance of a LocationType object with the type 'synthetic'.
 * @returns A new instance of the LocationType class with the type 'synthetic'.
 */
  static get Synthetic() {
    return new LocationType('syntheticGeo');
  }

/**
 * The function returns a new instance of a LocationType object with the type 'county'.
 * @returns A new instance of the LocationType class with the type 'county'.
 */
  static get County() {
    return new LocationType('county');
  }

/**
 * The function returns a new instance of a LocationType object with the type 'neighborhood'.
 * @returns A new instance of the LocationType class with the type 'neighborhood'.
 */
static get Neighborhood() {
  return new LocationType('neighborhood');
}

/**
 * The function returns a new instance of a LocationType object with the type 'schoolDistrict'.
 * @returns A new instance of the LocationType class with the type 'schoolDistrict'.
 */
static get SchoolDistrict() {
  return new LocationType('schoolDistrict');
}

  static fromKey(key) {
    const locationType = {
      city: LocationType.City,
      market: LocationType.Market,
      rectangulararea: LocationType.RectangularArea,
      zip: LocationType.Zip,
      syntheticgeo: LocationType.Synthetic,
      county: LocationType.County,
      neighborhood: LocationType.Neighborhood,
      schooldistrict: LocationType.SchoolDistrict,
    };
    return locationType[key.toLowerCase()];
  }

  constructor(name) {
    this.name = name;
  }

  /**
   * This is a toString() method in JavaScript that returns the name property of an object as a string.
   * @returns The `toString()` method is returning the value of the `name` property of the object.
   */
  toString() {
    return `${this.name}`;
  }
}